import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Grid, Tabs, Tab } from "@mui/material";
import { Typography } from "@totalsoft/rocket-ui";
import MessageIcon from "@mui/icons-material/Message";

let setContentFn, resetContentFn;

class RightSidebarContent extends React.PureComponent {
  state = {
    content: (
      <>
        <Tabs
          value={0}
          onChange={this.handleChange}
          variant="fullWidth"
          indicatorColor="secondary"
          textColor="secondary"
        >
          <Tab icon={<MessageIcon />} label={this.props.t("Messages")} />
        </Tabs>
        <Typography style={{ padding: 20 }}>{this.props.t("NoMessages")}</Typography>
      </>
    )
  };

  componentDidMount() {
    setContentFn = this.setContent;
    resetContentFn = this.resetContent;
  }

  setContent = content => {
    this.setState({ content });
  };
  resetContent = () => {
    this.setState({
      content: (
        <>
          <Tabs
            value={0}
            onChange={this.handleChange}
            variant="fullWidth"
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab icon={<MessageIcon />} label={this.props.t("Messages")} />
          </Tabs>
          <Typography style={{ padding: 20 }}>{this.props.t("NoMessages")}</Typography>
        </>
      )
    });
  };

  render() {
    return <Grid sx={{ overflow: "auto" }}>{this.state.content}</Grid>;
  }
}

RightSidebarContent.propTypes = {
  i18n: PropTypes.object,
  t: PropTypes.func.isRequired
};

export function setContent(content) {
  if (setContentFn === undefined) {
    setTimeout(() => setContentFn(content));
  } else {
    setContentFn(content);
  }
}
export function resetContent() {
  resetContentFn();
}

export default withTranslation(RightSidebarContent);
